module.exports = __webpack_public_path__ + "img/appointment_btn1.561ed1d0.png";